<template>
    <div class="areaOrder">
        <headers :title="'在线预约'"/>
        <!-- 地址栏 -->
          <div class="addressOut" @click="changeAddress">
                 <div class="addressContent" v-if="!!Address">
                     <div class="namePhone">
                         <div class="name">{{Address.guestName}}</div>
                         <div class="phone">{{Address.guestPhone}}</div>
                         <div class="acreage" v-if="Address.Acreage">{{Address.Acreage}}㎡</div>
                     </div>
                     <div class="address">
                        {{Address.guestAddress}}
                     </div>
                 </div>
                 <div class="addressContent" v-else>
                 </div>
                 <div class="addressRight">
                     <span class="iconfont iconyoujiantou"></span>
                 </div>
          </div>

           <!-- 服务项目 -->
           <div class="serviceItems">
               <p class="serviceTitle">服务项目</p>
               <div class="serviceText">
                   <p>{{ContentTitle}}</p>
                   <!-- <p>{{ContentDescription}}</p> -->
                   <p v-html="ContentDescription"></p>
               </div>
           </div>


           <!-- 服务流程 -->
           <div class="Serviceflow">
               <p class="flowTitle">服务流程</p>
                <img :src="ServiceFlowPicture.Url" alt="">
           </div>
           
            <!-- 选择时间 -->
            <div class="dateOut">
                <div class="title">请选择服务时间</div>
                <div class="date">
                     <Calendar
                     v-on:choseDay="clickDay"
                     :agoDayHide='agoDay' ref="calendar" :calendarIndex='calendarIndex'></Calendar>
                </div> 

                <div class="timeTable">
                    <div class="tableTitle">
                        <div>日期</div>
                        <div>上门时间</div>
                    </div>
                    <div class="tableContent" v-if="time">
                        <div>{{day}}</div>
                        <div>{{time}}</div>
                    </div>
                </div>

                 <van-cell-group class="message">
                    <van-field
                        v-model="message"
                        label="备注"
                        type="textarea"
                        placeholder="请输入留言"
                        rows="1"
                        autosize
                    />
                </van-cell-group>
            </div>
            <!-- 脚步导航 -->
        <div class="foot">
          <div class="kf"><a href="tel:4001500600">客服</a></div>
          <div class="confirm" @click="confirmOrder">确认下单</div>
        </div>
        <!-- 选择器 -->
        <van-popup v-model="isShowPicker" position="bottom" :overlay="true" @click-overlay="closePicker">
                  <van-picker :columns="columns" show-toolbar :title="`${newday}选择可上门报价日期`" @cancel="onCancel" @confirm="onConfirm" v-if="isShowPicker"/>
         </van-popup>
    </div>
</template>

<script>
import {mapState} from 'vuex'
import Calendar from '../../components/Calendar/index.js'
import { Toast } from 'vant'
import { parseTime } from "../../util/common-fun.js";
export default {
    data () {
        return {
            agoDay:null,
            newday:'',
            day:'',
            calendarIndex:[],
            isShowPicker: false,
            message:'',
            isShowPicker: false,
            columns: [
                {
                values:["07:00","07:30","08:00","08:30","09:00","09:30","10:00","10:30","11:00","11:30","12:00","12:30","13:00","13:30","14:00","14:30","15:00","15:30","16:00","16:30","17:00","17:30","18:00","18:30","19:00","19:30","20:00","20:30","21:00"]
                }
            ],
            time: '',
            ContentDescription: '',
            ContentTitle: '',
            ServiceFlowPicture: {},
            Address:{},
            ContentId: null,
            ServiceId: null,
            ContentType: '',
            isConfirmOrder: false,
            CanOrder:0, // 1-可预订
            CanNotOrderTips: "",//不可预订时提示
            
        }
    },
    computed:{
       ...mapState(['orderAddress'])
    },
    beforeRouteEnter(to, from, next) {
      if(from.name === 'AddressList') { //判断是从哪个路由过来的
          to.meta.isBack = true;
      }
      next();
    },
    created () {
      this.initCalendar()
       this.getData() 
    },
    mounted(){
      if (this.$route.meta.isBack){ // 选地址后 后退的数据
              if (this.orderAddress.length > 0) {
                this.Address = this.orderAddress[0]
              } 
              let areaObj = JSON.parse(localStorage.getItem('areaObj'))
              this.day = areaObj.day
              this.time = areaObj.time
              this.message = areaObj.message
             this.$refs.calendar.list.forEach((item,index) => {
                  if(this.day.split('-')[2] == item.date.split('/')[2] && this.day.split('-')[1].replace(/\b(0+)/gi,'') == item.date.split('/')[1]){
                    this.calendarIndex=[]
                    this.calendarIndex.push(this.day.split('-')[1].replace(/\b(0+)/gi,''))
                    this.calendarIndex.push(index)
                  }
                  item.chooseDay = false
                  if(this.calendarIndex[1] == index && item.date.split('/')[1] == this.calendarIndex[0]){
                    item.chooseDay = true
                  }
               })
                localStorage.removeItem('areaObj')
          }
    },
     /* activated(){
          if (this.orderAddress.length > 0) {
             this.Address = this.orderAddress[0]
          }  

          if(!this.$route.meta.isBack) {  // 不是后退，重新拿数据
             this.day = ''
             this.time = ''
             this.message = ''
             this.getData()
             this.$refs.calendar.historyChose = []
            }
            this.$route.meta.isBack = false
    }, */
    methods: {
      // 配置日历
      initCalendar(){
          let day = parseTime(new Date(), "{y}/{m}/{d}");
          let flag = this.isDuringDate(day + " " + "00:00", day + " " + "18:00");
          let curDate = new Date()
          let preDate = null
          if (flag) {
            preDate = (curDate.getTime()).toString().substr(0,10)
          }else{
            preDate = (curDate.getTime() + 24*60*60*1000).toString().substr(0,10)
          } 
          this.agoDay = preDate
        },
        //判断当前时间是否处于某个一个时间段内
        isDuringDate(beginDateStr, endDateStr) {
          var curDate = new Date(),
            beginDate = new Date(beginDateStr),
            endDate = new Date(endDateStr);
          if (curDate >= beginDate && curDate <= endDate) {
            return true;
          }
          return false;
        },
        getData () {
        
        // 发送请求
       let key = this.$route.query.by  === 'sid' ? 'ServiceId' : 'ContentId'
       let id = this.$route.query.id
       this.$axios.get('/api/DjOrder/GetContentInfo',{
          params: {

            [key]: id
          }
       }).then(res => {
         let data = res.data
         this.CanOrder = data.CanOrder
         this.CanNotOrderTips = data.CanNotOrderTips
         
         if(data.ContentDescription){
            this.ContentDescription = data.ContentDescription.replace(/\n/g, '<br/>').replace(/ /g, '&nbsp;')
          }

         this.ContentTitle = data.ContentTitle
         if (process.env.NODE_ENV === "development"){
           this.ServiceFlowPicture = JSON.parse(data.Pictures).ServiceFlowPicture.map((i) => {
                i.Url = 'http://www.lungchuenjz.cn' + i.Url
                return i
            })[0]
         }else{
           this.ServiceFlowPicture = JSON.parse(data.Pictures).ServiceFlowPicture[0]
         }
         
          this.ContentId = data.ContentId
          this.ServiceId = data.ServiceId
          this.ContentType = data.ContentType
       })
       // 获取地址请求
       if (this.orderAddress.length <= 0) {
               this.$axios.get('/api/DjAddress/GetAddressList').then(res => {
                  let data = res.data
                  if(data.length>0){
                    this.Address = data[0]
                  }
                })
          } 
        

        },
        clickDay (data) {
             console.log(data); //选中某天
             this.isShowPicker = !this.isShowPicker
             this.newday = data.replace(/\//g, "-")
        },
        onCancel() {
           this.$refs.calendar.historyChose = []
           this.isShowPicker = false
           this.$refs.calendar.list.forEach((item,index) => {
             
               item.chooseDay = false
               if(this.calendarIndex[1] == index && item.date.split('/')[1] == this.calendarIndex[0]){
               item.chooseDay = true
             }
           })
        },
        closePicker () {
           this.$refs.calendar.historyChose = []
           this.$refs.calendar.list.forEach((item,index) => {
             
               item.chooseDay = false
               if(this.calendarIndex[1] == index && item.date.split('/')[1] == this.calendarIndex[0]){
               item.chooseDay = true
             }
           })
        },
        onConfirm (value, index) {
          this.time = value[0]
          this.isShowPicker = false
          this.day = this.newday
          this.$refs.calendar.list.forEach((item,index) => {
            if(this.day.split('-')[2] == item.date.split('/')[2] && this.day.split('-')[1] == item.date.split('/')[1]){
            this.calendarIndex=[]
            this.calendarIndex.push(this.day.split('-')[1])
            this.calendarIndex.push(index)
            }
          })
        },
        changeAddress () {
          let _this = this
          let areaObj = {
            time:_this.time,
            day:_this.day,
            message:_this.message
          }
          localStorage.setItem('areaObj', JSON.stringify(areaObj))
          this.$router.push('/addresslist')
        },
        confirmOrder () {
          if(this.CanOrder == 0){
            Toast(this.CanNotOrderTips);
            return
          }

          if (!this.Address) {
            Toast('请输入有效地址信息！');
            return
            }
            
           if (this.time == '') {
             Toast('请选择服务日期！');
          }else {
             let ServiceRule = JSON.stringify({
              FirstServiceDate: this.day,
              FirstServiceTime: this.time,
              CustomerRemarks: this.message
            })

            if(!this.isConfirmOrder){
              this.isConfirmOrder = true

              // 提交订单
            this.$axios.post('/api/DjOrder/SaveOrder',{
              CustomerName: this.Address.guestName,
              CustomerPhone: this.Address.guestPhone,
              CustomerAddress: this.Address.guestAddress,
              Add0: this.Address.address0,
              Add1: this.Address.address1,
              Add2: this.Address.address2,
              Acreage: this.Address.Acreage,
              CustomerRemarks: this.message,
              OrderFlag: this.ContentType,
              ContentId: this.ContentId,
              ServiceId: this.ServiceId,
              ServiceRule
            }).then(res => {
              // console.log(res)
              if (res.data.type == 1 ) { 
                Toast.success({
                  message: '成功预订',
                  duration: 500
                })
                this.isConfirmOrder = false
                this.$router.push('/orderlist')
               }else{
                 this.isConfirmOrder = false
                 Toast(res.data.message);
               }
              
            }).catch(() => {
              this.isConfirmOrder = false
              Toast('提交失败，请重新提交！');
            })
            }
            

          }
        }
    },
     components: {
        Calendar
    }
    
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.areaOrder
  background: rgb(240, 240, 240)
  height: 100vh
  .addressOut
    width: 100%
    height: 80px
    margin-top: 45px
    background: #f7f4e4
    position: relative
    display: flex
    justify-content: center
    align-items: center
    font-size: 14px
    color: #6b6b6b
    &::before
     content:''
     position:absolute
     top:0
     width:100%
     height:4px
     background-image:url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAAAKBAMAAACOO0tGAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAnUExURf///4u16Oxtbezz/J3B7NDh9vvd3fSmprjS8vGNje57e/jDw/7w8IQ3dnAAAABSSURBVCjPY2CAAG4l7GADVJ4hUBArEIXJJ2HXrw6TZ8auX7ABKs+zCLsBE2AGmGDXLwKT58SuX+sATIEjdgOcYfJF2A1Qg8lz4PCBwWgQUiMIAWCaOFG2MdFRAAAAAElFTkSuQmCC")   
    &::after
     content:''
     position:absolute
     bottom:0
     width:100%
     height:4px
     background-image:url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAAAKBAMAAACOO0tGAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAnUExURf///4u16Oxtbezz/J3B7NDh9vvd3fSmprjS8vGNje57e/jDw/7w8IQ3dnAAAABSSURBVCjPY2CAAG4l7GADVJ4hUBArEIXJJ2HXrw6TZ8auX7ABKs+zCLsBE2AGmGDXLwKT58SuX+sATIEjdgOcYfJF2A1Qg8lz4PCBwWgQUiMIAWCaOFG2MdFRAAAAAElFTkSuQmCC")
    .addressContent
      height: 100%
      width: 90%
      margin-left: -2px
      display: flex
      flex-direction: column
      justify-content: center
      padding: 5px
      .namePhone
        display: flex
        margin-bottom: 12px
        .name
          margin-right: 12px
        .phone
          margin-right: 64px
    .addressRight
      &>span
        font-size: 28px
  .serviceItems
    width: 100%
    background: white
    margin-top: 6px
    padding-left: 8px
    padding-top: 8px
    box-sizing: border-box
    padding-bottom: 8px
    .serviceTitle
      margin-bottom: 6px
      font-size: 14px
    .serviceText
      width: 96%
      border: 1px solid #bfbfbf
      border-radius: 6px
      padding: 8px
      box-sizing: border-box
      background: rgb(240, 240, 240)
      font-size: 13px
      line-height: 18px
      color: #333
      &>p:last-child
        margin-top: 4px
  .Serviceflow
    width: 100%
    background: white
    border-top: 1px solid #eee
    .flowTitle
      padding-left: 6px
      padding-top: 6px
      font-size: 14px
    &>img
      width: 100%
  .dateOut
     width: 100%
     background: white
     border-bottom: 1px solid #eee
     margin-top: 8px
     .title
       width: 90%
       margin-top: 6px
       padding: 10px
       font-size: 14px
       color: #333
     .date
       width: 100%
       margin: auto
       border-top: 1px solid #eee
       border-bottom: 1px solid #eee
       &>>>.wh_container
         max-width: 100%
         .wh_content_all
          background-color: white
          & .wh_jiantou1
            border-top: 2px solid #009933;
            border-left: 2px solid #009933;
          & .wh_jiantou2
            border-top: 2px solid #009933;
            border-right: 2px solid #009933;
          & .wh_content_li
            color: #009933
          & .wh_item_date
            color: #009933
            background-color: white
          & .wh_item_date.wh_chose_day
            background-color: #009933;color: white
          & .wh_item_date.wh_want_dayhide
            color: #bfbfbf
          & .wh_item_date.wh_other_dayhide
            color: #bfbfbf
     .timeTable
       width: 98%
       margin: 5px auto
       display: flex
       flex-direction: column
       background: white
       font-size: 14px
       .tableTitle
         display: flex
         &>div
          width: 50%
          display: flex
          justify-content: center
          align-items: center
          border: 1px solid #bfbfbf
          border-right: none
          height: 30px
          &:last-child
           border-right: 1px solid #bfbfbf
       .tableContent
         display: flex
         &>div
          width: 50%
          display: flex
          justify-content: center
          align-items: center
          border: 1px solid #bfbfbf
          border-right: none
          border-top: none
          height: 30px
          &:last-child
           border-right: 1px solid #bfbfbf
     .message
       margin-bottom: 42px
  .foot
    width: 100%
    height: 40px
    position: fixed
    left: 0
    right: 0
    bottom: 0
    display: flex
    .confirm
      width: 70%
      height: 100%
      background: #c21a1a
      text-align: center
      line-height: 40px
      color: white
    .kf
      width: 30%
      height: 100%
      background: #009933
      text-align: center
      line-height: 40px
      color: white
      & a
        color white
        display: inline-block
        width 100%
        height 100%
        display flex
        align-items center
        justify-content center
  >>> .van-ellipsis
   overflow: visible
   max-width: 100%
</style>



// WEBPACK FOOTER //
// src/pages/Order/AreaOrder.vue